import styled, { css } from "styled-components";
import type { BadgeVariantsType } from "./Badge";

// STYLES
const commonStyles = css`
    flex-shrink: 0;
    text-align: center;
    border: 2px solid;
`;

const count = css`
    ${commonStyles};
    min-width: 22px;
    padding: calc(var(--spacing-1) / 2);
    font-family: var(--font-semi-bold);
    font-size: 1.1rem;
    line-height: 50%;
    color: var(--color-primary-white);
    background-color: var(--color-primary-black);
    border-color: var(--color-primary-black);
    border-radius: 6rem;
`;

const pill = css`
    ${commonStyles};
    padding: calc(var(--spacing-3) / 2) var(--spacing-2);
    font-family: var(--font-regular);
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: var(--color-primary-white);
    background-color: var(--color-primary-black);
    border-radius: 32px;
    opacity: 0.9;
`;

const pillSmall = css`
    ${commonStyles};
    display: inline-block;
    padding: calc(var(--spacing-2) / 2) var(--spacing-2);
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-white);
    background-color: var(--color-primary-black);
    border-radius: 20px;
    opacity: 0.8;
`;

// COMPONENT
export const BadgeVariants = {
    count,
    pill,
    "pill-small": pillSmall,
};

const BadgeVariant = styled.span<{ variant: BadgeVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${BadgeVariants[variant]};
        `};
`;

export default BadgeVariant;
